import { myAxios } from "./axios";

export function getLeadContacts(payload, { page, limit }) {
  let config = {
    params: {
      page,
      limit,
      ...(payload || {}), 
    },
  };
  return myAxios.get("/lead-contacts", config);
}

export function getLeadContact(id) {
  return myAxios.get("/lead-contacts/" + id);
}

export function addLeadContact(data) {
  return myAxios.post("/lead-contacts/add", data);
}

export function editLeadContact(id, data) {
  return myAxios.put(`/lead-contacts/edit/${id}`, data);
}

export function deleteLeadContact(id) {
  return myAxios.delete("/lead-contacts/" + id);
}
